if (!customElements.get('flipzy-quote')) {
  customElements.define(
    'flipzy-quote',
    class FlipzyQuote extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized || this.dataset.randomize !== 'true' || window.Shopify?.designMode) return;

        const display = this.querySelector('[data-quote-display]');
        const pool = this.querySelector('[data-quote-pool]');
        if (!display || !pool) return;

        // Read the other visible selections, including fixed / no-script fallbacks.
        // No persistent storage, timer, or page-wide event listener is needed.
        const used = new Set(
          Array.from(document.querySelectorAll('flipzy-quote [data-quote-display] [data-quote-key]'))
            .filter((quote) => !this.contains(quote))
            .map((quote) => quote.dataset.quoteKey)
        );
        const candidates = Array.from(pool.content.querySelectorAll('[data-quote-key]'));
        const available = candidates.filter((quote) => !used.has(quote.dataset.quoteKey));
        const choices = available.length ? available : candidates;
        if (!choices.length) return;

        const selected = choices[Math.floor(Math.random() * choices.length)];
        display.replaceChildren(selected.cloneNode(true));
        this.dataset.initialized = 'true';
        pool.remove();
      }
    }
  );
}
